'use client';

import React, { useEffect, useState } from 'react';
import AppButton from '@/src/app/components/Button/AppButton.tsx';
import { getDictionary } from '@/src/lib/dictionary/dictionaries.ts';
import { Dictionary } from '@/src/lib/dictionary/types.ts';
import Cookies from 'js-cookie';
import { defaultLocale, languageCookieName } from '@/src/lib/dictionary/settings.ts';
import { handleException } from '@/src/lib/core/exception/handle-exception.ts';
import { IconName } from '@/src/app/components/Icon/types.ts';

function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const lang = Cookies.get(languageCookieName) || defaultLocale;
  const [dict, setDict] = useState<Dictionary | null>(null);

  useEffect(() => {
    (async () => {
      if (dict) return;
      setDict(await getDictionary(lang));
    })();

    handleException(error);
  }, [error, dict, lang]);

  if (!dict) return null;

  return (
    <main className="mx-auto flex w-full max-w-7xl flex-auto flex-col justify-center px-6 py-24 sm:py-64 lg:px-8 text-center">
      <h1 className="mt-4 display-title-5xl">{dict.errorPage.title}</h1>
      <p className="mt-6 text-base leading-7 text-gray-600"> {dict.errorPage.description}</p>
      <div className="mt-10 flex gap-4 justify-center">
        <AppButton href="/" primary priority icon={IconName.HOME}>
          {dict.errorPage.backToHomeBtn}
        </AppButton>
        <AppButton onClick={reset} priority className="text-sm font-semibold leading-7" icon={IconName.REFRESH}>
          {dict.errorPage.resetBtn}
        </AppButton>
      </div>
    </main>
  );
}

export default Error;
